import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getAnalyticsUser } from '../../../selectors/analytics';
import { IBrokerAnalyticsUser, TBrokerFlow } from '../../../types/newbuildingBroker';

export const useBrokerAnalyticsUser = (brokerFlow: TBrokerFlow | null) => {
  const user = useSelector(getAnalyticsUser);

  return useMemo<IBrokerAnalyticsUser>(
    () => ({
      ...user,
      extra: {
        is_individual: brokerFlow === 'withPartnerRewards',
      },
    }),
    [user, brokerFlow],
  );
};
